import { CustomisedTertiaryButton, CPButton, FullScreenModalButtonWrapper } from "../../../constants/common/StyledGlobalConstants";
import { Line } from "@vds/lines";
import styled from "styled-components";
import { getPendoId } from "../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { MOBILE } = DEVICE_BREAKPOINTS;

const getGridTemplateColumns = (props) => {
  if (props.isReschedule && (props.isApiFailed || props.isJobScheduleDateIsWithInThreeBusinessDays)) {
    return "100%";
  } else if (props.step < 2 && !props.back) {
    return "45% 45%";
  } else {
    return "100%";
  }
};

const getGridTemplateRows = (props) => {
  if (props.isApiFailed) {
    return "1fr";
  } else if (props.step < 2 && !props.back) {
    return "1fr";
  } else if (
    props.step === 5 ||
    (props.step === 3 && props.back) ||
    (props.step === 4 && props.isJobDurationExceeds10Hrs)
  ) {
    return "1fr";
  } else {
    return "repeat(3, 1fr)";
  }
};


const CFSTFullScreenModalButtonWrapper = styled(FullScreenModalButtonWrapper)`
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: ${(props) => getGridTemplateColumns(props)};
    grid-template-rows: ${(props) => getGridTemplateRows(props)};
    ${(props) =>
      (props.step > 1 || (props.step === 1 && props.back)) &&
      `
    button:nth-child(1) {
      order: 3;
    }
    button:nth-child(2) {
      order: 2;
    }
    button:nth-child(3) {
      order: 1;
    }     
  `}
  }
  @media (min-width: 361px) {
    padding: 12px 16px;
  }
  width: 100%;
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 98%;
  }
  @media (min-width: 1024px) {
    width: 78.5%;
  }
  @media (min-width: 1920px) {
    width: 71.8%;
  }
`;

// Helper components for each branch

const RescheduleApiFailedOrWithinThreeDays = ({
  step,
  back,
  regionId,
  isApiFailed,
  isReschedule,
  isJobScheduleDateIsWithInThreeBusinessDays,
  windowSize,
  handleCancel,
}) => (
  <CFSTFullScreenModalButtonWrapper
    back={(isReschedule && back)}
    step={step}
    showLiveChat={regionId === "840" || regionId === "124"}
    isApiFailed={isApiFailed}
    isReschedule={isReschedule}
    isJobScheduleDateIsWithInThreeBusinessDays={isJobScheduleDateIsWithInThreeBusinessDays}
  >
    {step === 1 && (
      <CustomisedTertiaryButton
        aria-label="Close"
        buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
        onClick={handleCancel}
        id={getPendoId("footer-close-button")}
      >
        CLOSE
      </CustomisedTertiaryButton>
    )}
  </CFSTFullScreenModalButtonWrapper>
);

RescheduleApiFailedOrWithinThreeDays.propTypes = {
  step: PropTypes.number.isRequired,
  back: PropTypes.bool,
  regionId: PropTypes.string,
  isApiFailed: PropTypes.bool,
  isReschedule: PropTypes.bool,
  isJobScheduleDateIsWithInThreeBusinessDays: PropTypes.bool,
  windowSize: PropTypes.object,
  handleCancel: PropTypes.func,
};

const RescheduleNormal = ({
  step,
  back,
  regionId,
  windowSize,
  handleFooterCancelValidate,
  handleStepNavigate,
  handleCancel,
  isNextDisabled,
}) => (
  <CFSTFullScreenModalButtonWrapper
    back={back}
    step={step}
    showLiveChat={regionId === "840" || regionId === "124"}
  >
    {step < 3 && (
      <CustomisedTertiaryButton
        aria-label="Cancel"
        buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
        onClick={handleFooterCancelValidate}
        id={getPendoId("footer-cancel-button")}
      >
        CANCEL
      </CustomisedTertiaryButton>
    )}
    {back && step !== 3 && ( 
      <CPButton
        secondary
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        boxButton
        aria-label="Back"
        id={getPendoId("footer-back-button")}
        onClick={() => {
          handleStepNavigate("back");
        }}
      >
        BACK
      </CPButton>
    )}

    {step === 2 ? (
      <CPButton
        boxButton
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        aria-label="RESCHEDULE"
        id={getPendoId("footer-reschedule-button")}
        onClick={() => handleStepNavigate("next")}
      >
        RESCHEDULE
      </CPButton>
    ) : (
      <CPButton
        boxButton
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        aria-label={step < 3 ? "Next" : "Close"}
        fontPaddingLeft="0.75rem"
        fontPaddingRight="0.75rem"
        onClick={() => {
          step < 3 ? handleStepNavigate("next") : handleCancel();
        }}
        disabled={isNextDisabled}
        id={step < 2 ? getPendoId("footer-next-button") : getPendoId("footer-close-button")}
      >
        {step < 3 ? "NEXT" : "CLOSE"}
      </CPButton>
    )}
  </CFSTFullScreenModalButtonWrapper>
);

RescheduleNormal.propTypes = {
  step: PropTypes.number.isRequired,
  back: PropTypes.bool,
  regionId: PropTypes.string,
  windowSize: PropTypes.object,
  handleFooterCancelValidate: PropTypes.func,
  handleStepNavigate: PropTypes.func,
  handleCancel: PropTypes.func,
  isNextDisabled: PropTypes.bool,
};

const AssistanceRequiredFooter = ({
  step,
  back,
  regionId,
  windowSize,
  handleFooterCancelValidate,
  handleStepNavigate,
  handleCancel,
  isNextDisabled,
}) => {
  let ariaLabel;
  if (step === 1 || step === 2) {
    ariaLabel = "Next";
  } else if (step === 3) {
    ariaLabel = "Submit";
  } else {
    ariaLabel = "Close";
  }

  // Extract id for CPButton to avoid nested ternary in JSX
  let cpButtonId;
  if (step === 1 || step === 2) {
    cpButtonId = getPendoId("footer-next-button");
  } else if (step === 3) {
    cpButtonId = getPendoId("footer-submit-button");
  } else {
    cpButtonId = getPendoId("footer-close-button");
  }

  return (
    <CFSTFullScreenModalButtonWrapper
      back={back}
      step={step}
      showLiveChat={regionId === "840" || regionId === "124"}
    >
      {step < 4 && (
        <>
          <CustomisedTertiaryButton
            aria-label="Cancel"
            buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
            onClick={handleFooterCancelValidate}
            id={getPendoId("footer-cancel-button")}
          >
            CANCEL
          </CustomisedTertiaryButton>
          {step !== 1 && (
            <CPButton
              secondary
              width={windowSize.width >= MOBILE ? "auto" : "97%"}
              fontSize="0.875rem"
              boxButton
              aria-label="Back"
              id={getPendoId("footer-back-button")}
              onClick={() => {
                handleStepNavigate("back");
              }}
            >
              BACK
            </CPButton>
          )}
        </>
      )}

      {/*
        Extract the button label to avoid nested ternary in JSX
      */}
      {(() => {
        let buttonLabel;
        if (step === 1 || step === 2) {
          buttonLabel = "NEXT";
        } else if (step === 3) {
          buttonLabel = "SUBMIT";
        } else {
          buttonLabel = "CLOSE";
        }
        return (
          <CPButton
            boxButton
            width={windowSize.width >= MOBILE ? "auto" : "97%"}
            fontSize="0.875rem"
            aria-label={ariaLabel}
            fontPaddingLeft="0.75rem"
            fontPaddingRight="0.75rem"
            onClick={() => {
              let action;
              if (step === 1 || step === 2) {
                action = () => handleStepNavigate("next");
              } else if (step === 3) {
                action = () => handleStepNavigate("submit");
              } else {
                action = handleCancel;
              }
              action();
            }}
            id={cpButtonId}
            disabled={isNextDisabled}
          >
            {buttonLabel}
          </CPButton>
        );
      })()}
    </CFSTFullScreenModalButtonWrapper>
  );
};

AssistanceRequiredFooter.propTypes = {
  step: PropTypes.number.isRequired,
  back: PropTypes.bool,
  regionId: PropTypes.string,
  windowSize: PropTypes.object,
  handleFooterCancelValidate: PropTypes.func,
  handleStepNavigate: PropTypes.func,
  handleCancel: PropTypes.func,
  isNextDisabled: PropTypes.bool,
};

const ApiFailedFooter = ({
  step,
  regionId,
  isApiFailed,
  windowSize,
  handleCancel,
}) =>
  (step === 2 || step === 3) && (
    <CFSTFullScreenModalButtonWrapper isApiFailed={isApiFailed} showLiveChat={regionId === "840" || regionId === "124"}>
      <CustomisedTertiaryButton
        boxButton
        aria-label="Close"
        buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
        onClick={handleCancel}
        id={getPendoId("footer-close-button")}
      >
        CLOSE
      </CustomisedTertiaryButton>
    </CFSTFullScreenModalButtonWrapper>
  );

ApiFailedFooter.propTypes = {
  step: PropTypes.number.isRequired,
  regionId: PropTypes.string,
  isApiFailed: PropTypes.bool,
  windowSize: PropTypes.object,
  handleCancel: PropTypes.func,
};

const JobDurationExceedsFooter = ({
  step,
  back,
  regionId,
  windowSize,
  handleFooterCancelValidate,
  handleStepNavigate,
  handleCancel,
  isNextDisabled,
  isJobDurationExceeds10Hrs,
}) => (
  <CFSTFullScreenModalButtonWrapper
    back={back}
    step={step}
    showLiveChat={regionId === "840" || regionId === "124"}
    isJobDurationExceeds10Hrs={isJobDurationExceeds10Hrs}
  >
    {step < 4 && (
      <>
        <CustomisedTertiaryButton
          boxButton
          aria-label="Cancel"
          buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
          onClick={handleFooterCancelValidate}
          id={getPendoId("footer-cancel-button")}
        >
          CANCEL
        </CustomisedTertiaryButton>
        {step !== 1 && (
          <CPButton
            secondary
            width={windowSize.width >= MOBILE ? "auto" : "97%"}
            fontSize="0.875rem"
            boxButton
            aria-label="Back"
            id={getPendoId("footer-back-button")}
            onClick={() => {
              handleStepNavigate("back");
            }}
          >
            BACK
          </CPButton>
        )}
      </>
    )}
    {/*
      Extract aria-label to avoid nested ternary
    */}
    {(() => {
      let ariaLabel;
      if (step === 1 || step === 2) {
        ariaLabel = "Next";
      } else if (step === 3) {
        ariaLabel = "Submit";
      } else {
        ariaLabel = "Close";
      }
      // Extract CPButton ID to avoid nested ternary in JSX
      let CPButton_ID;
      if (step === 1 || step === 2) {
        CPButton_ID = getPendoId("footer-next-button");
      } else if (step === 3) {
        CPButton_ID = getPendoId("footer-submit-button");
      } else {
        CPButton_ID = getPendoId("footer-close-button");
      }
      // Extract button label to avoid nested ternary
      let buttonLabel;
      if (step === 1 || step === 2) {
        buttonLabel = "NEXT";
      } else if (step === 3) {
        buttonLabel = "SUBMIT";
      } else {
        buttonLabel = "CLOSE";
      }
      return (
        <CPButton
          boxButton
          width={windowSize.width >= MOBILE ? "auto" : "97%"}
          fontSize="0.875rem"
          aria-label={ariaLabel}
          fontPaddingLeft="0.75rem"
          fontPaddingRight="0.75rem"
          onClick={() => {
            let action;
            if (step === 1 || step === 2) {
              action = () => handleStepNavigate("next");
            } else if (step === 3) {
              action = () => handleStepNavigate("submit");
            } else {
              action = handleCancel;
            }
            action();
          }}
          id={CPButton_ID}
          disabled={isNextDisabled}
        >
          {buttonLabel}
        </CPButton>
      );
    })()}
  </CFSTFullScreenModalButtonWrapper>
);

JobDurationExceedsFooter.propTypes = {
  step: PropTypes.number.isRequired,
  back: PropTypes.bool,
  regionId: PropTypes.string,
  windowSize: PropTypes.object,
  handleFooterCancelValidate: PropTypes.func,
  handleStepNavigate: PropTypes.func,
  handleCancel: PropTypes.func,
  isNextDisabled: PropTypes.bool,
  isJobDurationExceeds10Hrs: PropTypes.bool,
};

const DefaultFooter = ({
  step,
  back,
  regionId,
  windowSize,
  handleFooterCancelValidate,
  handleStepNavigate,
  handleCancel,
  isNextDisabled,
}) => (
  <CFSTFullScreenModalButtonWrapper
    back={back}
    step={step}
    showLiveChat={regionId === "840" || regionId === "124"}
  >
    {step < 5 && (
      <CustomisedTertiaryButton
        boxButton
        aria-label="Cancel"
        buttonWidth={windowSize.width >= MOBILE ? "auto" : "97%"}
        onClick={handleFooterCancelValidate}
        id={getPendoId("footer-cancel-button")}
      >
        CANCEL
      </CustomisedTertiaryButton>
    )}
    {step > 1 && step < 5 && (
      <CPButton
        secondary
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        boxButton
        aria-label="Back"
        id={getPendoId("footer-back-button")}
        onClick={() => {
          handleStepNavigate("back");
        }}
      >
        BACK
      </CPButton>
    )}

    {step === 4 ? (
      <CPButton
        boxButton
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        aria-label="Schedule"
        id={getPendoId("footer-schedule-button")}
        onClick={() => handleStepNavigate("next")}
      >
        SCHEDULE
      </CPButton>
    ) : (
      <CPButton
        boxButton
        width={windowSize.width >= MOBILE ? "auto" : "97%"}
        fontSize="0.875rem"
        aria-label={step < 5 ? "Next" : "Close"}
        fontPaddingLeft="0.75rem"
        fontPaddingRight="0.75rem"
        onClick={() => {
          step < 5 ? handleStepNavigate("next") : handleCancel();
        }}
        id={step < 4 ? getPendoId("footer-next-button") : getPendoId("footer-close-button")}
        disabled={isNextDisabled}
      >
        {step < 5 ? "NEXT" : "CLOSE"}
      </CPButton>
    )}
  </CFSTFullScreenModalButtonWrapper>
);

DefaultFooter.propTypes = {
  step: PropTypes.number.isRequired,
  back: PropTypes.bool,
  regionId: PropTypes.string,
  windowSize: PropTypes.object,
  handleFooterCancelValidate: PropTypes.func,
  handleStepNavigate: PropTypes.func,
  handleCancel: PropTypes.func,
  isNextDisabled: PropTypes.bool,
};

function getBackProp(step, currentIndex, isReschedule, isAssistanceRequired) {
  const back = (step === 1 && currentIndex === 1) || (step > 1 && step < 3);
  return (isReschedule && back) || (step === 3 && (isReschedule || isAssistanceRequired));
}

function getFooterContent({
  step,
  handleStepNavigate,
  isNextDisabled,
  handleFooterCancelValidate,
  windowSize,
  regionId,
  handleCancel,
  isReschedule,
  currentIndex,
  isAssistanceRequired,
  isApiFailed,
  isJobScheduleDateIsWithInThreeBusinessDays,
  isJobDurationExceeds10Hrs,
}) {
  const backProp = getBackProp(step, currentIndex, isReschedule, isAssistanceRequired);

  if (isReschedule) {
    if (isApiFailed || isJobScheduleDateIsWithInThreeBusinessDays) {
      return (
        <RescheduleApiFailedOrWithinThreeDays
          step={step}
          back={backProp}
          regionId={regionId}
          isApiFailed={isApiFailed}
          isReschedule={isReschedule}
          isJobScheduleDateIsWithInThreeBusinessDays={isJobScheduleDateIsWithInThreeBusinessDays}
          windowSize={windowSize}
          handleCancel={handleCancel}
        />
      );
    }
    return (
      <RescheduleNormal
        step={step}
        back={backProp}
        regionId={regionId}
        windowSize={windowSize}
        handleFooterCancelValidate={handleFooterCancelValidate}
        handleStepNavigate={handleStepNavigate}
        handleCancel={handleCancel}
        isNextDisabled={isNextDisabled}
      />
    );
  }
  if (isAssistanceRequired) {
    return (
      <AssistanceRequiredFooter
        step={step}
        back={backProp}
        regionId={regionId}
        windowSize={windowSize}
        handleFooterCancelValidate={handleFooterCancelValidate}
        handleStepNavigate={handleStepNavigate}
        handleCancel={handleCancel}
        isNextDisabled={isNextDisabled}
      />
    );
  }
  if (isApiFailed && !isReschedule) {
    return (
      <ApiFailedFooter
        step={step}
        regionId={regionId}
        isApiFailed={isApiFailed}
        windowSize={windowSize}
        handleCancel={handleCancel}
      />
    );
  }
  if (isJobDurationExceeds10Hrs) {
    return (
      <JobDurationExceedsFooter
        step={step}
        back={backProp}
        regionId={regionId}
        windowSize={windowSize}
        handleFooterCancelValidate={handleFooterCancelValidate}
        handleStepNavigate={handleStepNavigate}
        handleCancel={handleCancel}
        isNextDisabled={isNextDisabled}
        isJobDurationExceeds10Hrs={isJobDurationExceeds10Hrs}
      />
    );
  }
  return (
    <DefaultFooter
      step={step}
      back={backProp}
      regionId={regionId}
      windowSize={windowSize}
      handleFooterCancelValidate={handleFooterCancelValidate}
      handleStepNavigate={handleStepNavigate}
      handleCancel={handleCancel}
      isNextDisabled={isNextDisabled}
    />
  );
}

const Footer = ({
  step,
  handleStepNavigate,
  isNextDisabled,
  handleFooterClose,
  handleFooterCancelValidate,
  windowSize,
  regionId,
  handleCancel,
  isReschedule,
  currentIndex,
  isAssistanceRequired,
  isApiFailed = false,
  isJobScheduleDateIsWithInThreeBusinessDays,
  isJobDurationExceeds10Hrs,
}) => {
  const content = getFooterContent({
    step,
    handleStepNavigate,
    isNextDisabled,
    handleFooterCancelValidate,
    windowSize,
    regionId,
    handleCancel,
    isReschedule,
    currentIndex,
    isAssistanceRequired,
    isApiFailed,
    isJobScheduleDateIsWithInThreeBusinessDays,
    isJobDurationExceeds10Hrs,
  });

  return (
    <footer
      className="sticky-bottom-footer"
      style={{
        position: "fixed",
        bottom: "0",
        height: "auto",
        width: "100%",
      }}
      id="full-screen-modal-footer"
    >
      <Line type="xLight" inverted={false} />
      {content}
    </footer>
  );
};

Footer.propTypes = {
  step: PropTypes.number.isRequired,
  handleStepNavigate: PropTypes.func,
  isNextDisabled: PropTypes.bool,
  handleFooterClose: PropTypes.func,
  handleFooterCancelValidate: PropTypes.func,
  windowSize: PropTypes.object,
  regionId: PropTypes.string,
  handleCancel: PropTypes.func,
  isReschedule: PropTypes.bool,
  currentIndex: PropTypes.number,
  isAssistanceRequired: PropTypes.bool,
  isApiFailed: PropTypes.bool,
  isJobScheduleDateIsWithInThreeBusinessDays: PropTypes.bool,
  isJobDurationExceeds10Hrs: PropTypes.bool,
};

export default Footer;
